/**
 * Sanitising of free text that one player types and OTHER players see (names, room names, chat,
 * operation names that show up in enemy intercepts). Applied by the server on every inbound
 * string; the client uses the same functions to preview exactly what will be shown.
 */
import { LIMITS } from './limits';

/**
 * Control, format (zero-width, bidi overrides — used for spoofing), private-use, lone surrogate
 * and line/paragraph separator characters.
 */
const INVISIBLE = /[\p{Cc}\p{Cf}\p{Co}\p{Cs}\p{Zl}\p{Zp}]/gu;
/** Keep at most two stacked combining marks ("Zalgo" text would otherwise overflow every row). */
const MARK_STACK = /(\p{M}{2})\p{M}+/gu;
const WHITESPACE = /\s+/gu;

/**
 * NFKC-normalise, strip invisible characters, collapse whitespace, trim and cut to `max` code
 * points. May return an empty string — callers decide whether that is an error or a default.
 */
export function sanitizeText(raw: string, max: number): string {
  // Whitespace first so "a\nb" becomes "a b" rather than "ab"; again after stripping, because
  // removing invisible characters can leave adjacent spaces behind.
  const cleaned = raw
    .normalize('NFKC')
    .replace(WHITESPACE, ' ')
    .replace(INVISIBLE, '')
    .replace(MARK_STACK, '$1')
    .replace(WHITESPACE, ' ')
    .trim();
  const chars = Array.from(cleaned);
  return chars.length <= max ? cleaned : chars.slice(0, max).join('').trimEnd();
}

export function sanitizeName(raw: string): string {
  return sanitizeText(raw, LIMITS.playerName);
}
